import * as React from 'react';
import { Button as FlowBiteButton, ButtonProps as FlowBiteButtonProps } from 'flowbite-react';
import { ButtonColorsEnum, ButtonSizesEnum, buttonTheme } from '../../styles/themes/button';
import { Text } from '../text';

export type ButtonProps = Omit<FlowBiteButtonProps, 'label' | 'size' | 'color'> & {
    label?: string;
    size: ButtonSizesEnum;
    color: ButtonColorsEnum;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    ariaLabel?: string;
    testId?: string;
    isSelected?: boolean;
};

export const Button: React.FC<ButtonProps> = (props) => {
    const { label, startIcon, endIcon, testId, isSelected, ariaLabel, ...otherProps } = props;

    return (
        <FlowBiteButton
            theme={buttonTheme}
            data-testid={testId}
            data-selected={isSelected ? 'true' : undefined}
            aria-label={ariaLabel}
            {...otherProps}
        >
            {startIcon ? startIcon : null}
            {!!label ? <Text variant='label-medium'>{label}</Text> : null}
            {endIcon ? endIcon : null}
        </FlowBiteButton>
    );
};
